import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Alert,
  Spinner,
} from "react-bootstrap";
import { motion } from "framer-motion";
import { FaUserLock, FaMobileAlt, FaLock } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import "./login.css";

const Login = () => {
  const navigate = useNavigate();

  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");

  // 🔥 RESET STATES
  const [newPassword, setNewPassword] = useState("");
  const [showReset, setShowReset] = useState(false);
  const [success, setSuccess] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // ================= LOGIN =================
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    try {
     const res = await axios.post(
  "https://admin.soulliqo.com/admin/auth/login",
  {
    mobile: mobile.trim(),   // 👈 STRING, NOT NUMBER
    password: password,
  },
  {
    headers: {
      "Content-Type": "application/json",
    },
  }
);


      localStorage.setItem("token", res.data.token);
      localStorage.setItem("userId", res.data.user.id);
      localStorage.setItem("userName", res.data.user.name);

      navigate("/dashboard");
    } catch (err) {
      setError(err.response?.data?.message || "Login failed. Try again.");
    } finally {
      setLoading(false);
    }
  };

  // ================= DEV LOGIN =================
  const handleDirectLogin = async () => {
    setError("");
    setSuccess("");
    setLoading(true);

    try {
      const res = await axios.post(
        "https://admin.soulliqo.com/admin/auth/login",
        {
          mobile: "9727716480",
          password: "Admin@2026#chocolate",
        }
      );

      localStorage.setItem("token", res.data.token);
      localStorage.setItem("userId", res.data.user.id);
      localStorage.setItem("userName", res.data.user.name);

      navigate("/dashboard"); 
    } catch (err) {
      setError(err.response?.data?.message || "Dev login failed.");
    } finally {
      setLoading(false);
    }
  };

  // ================= RESET PASSWORD =================
  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    try {
      const res = await axios.post(
        "https://admin.soulliqo.com/admin/auth/reset-password",
        {
          mobile: Number(mobile),
          newPassword,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setSuccess(res.data.message || "Password reset successful");
      setShowReset(false);
      setNewPassword("");
    } catch (err) {
      setError(err.response?.data?.message || "Reset failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <Container fluid>
        <Row className="justify-content-center align-items-center min-vh-100">
          <Col xl={4} lg={5} md={7} sm={10}>
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <Card className="login-card">
                <motion.div
                  initial={{ scale: 0.8, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  transition={{ delay: 0.2 }}
                  className="login-header text-center"
                >
                  <FaUserLock className="login-icon" size={50} />
                  <h4>Admin Login</h4>
                  <p>Sign in to your dashboard</p>
                </motion.div>

                {error && <Alert variant="danger">{error}</Alert>}
                {success && <Alert variant="success">{success}</Alert>}

                {/* ===== FORGOT PASSWORD ===== */}
                {/* <div className="text-end mb-2">
                  <Button
                    variant="link"
                    className="p-0"
                    onClick={() => setShowReset(!showReset)}
                  >
                    Forgot Password?
                  </Button>
                </div> */}

                {showReset && (
                  <Card className="p-3 mb-3">
                    <Form onSubmit={handleResetPassword}>
                      <Form.Group className="mb-2">
                        <Form.Control
                          type="password"
                          placeholder="Enter new password"
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                          required
                        />
                      </Form.Group>

                      <Button
                        variant="warning"
                        size="sm"
                        type="submit"
                        disabled={loading}
                      >
                        {loading ? "Resetting..." : "Reset Password"}
                      </Button>
                    </Form>
                  </Card>
                )}

                {/* ===== LOGIN FORM ===== */}
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>Mobile Number</Form.Label>
                    <div className="input-icon">
                      <FaMobileAlt />
                      <Form.Control
                        type="text"
                        placeholder="Enter mobile number"
                        value={mobile}
                        onChange={(e) => setMobile(e.target.value)}
                        required
                      />
                    </div>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Password</Form.Label>
                    <div className="input-icon">
                      <FaLock />
                      <Form.Control
                        type="password"
                        placeholder="Enter password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                    </div>
                  </Form.Group>

                  <Button
                    type="submit"
                    className="login-btn w-100"
                    disabled={loading}
                  >
                    {loading ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      "Login"
                    )}
                  </Button>

                  {/* OPTIONAL DEV BUTTON */}
                  {/* <Button
                    variant="secondary"
                    className="w-100 mt-2"
                    onClick={handleDirectLogin}
                    disabled={loading}
                  >
                    Dev Login
                  </Button> */}
                </Form>
              </Card>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;
